/**
 * Product Form Components
 *
 */

 window.subscriptionFlow = {
  decor:'',
  decor_style:'',
  variant_id:null,
  selling_plan_id:null,
  redirect_url:''
}
window.prepaid_gift={
  variant_id:null,
  selling_plan_id:null
}
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    //this.querySelector('[addCart_btn]').addEventListener('click',this.Add_btn.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
    if(document.querySelectorAll('[subscription_btn]').length > 0){
      document.querySelectorAll('[subscription_btn]').forEach((selector)=>{
        selector.addEventListener('click',(event)=>{
           let $this = event.currentTarget;
            let parent = $this.closest('.pdp-subscription-modal')
          if(window.subscriptionFlow.decor_style == '' || window.subscriptionFlow.decor_style == undefined){
            parent.querySelector('[error_message]').innerText = 'Please select the style';
            return;
          }else if(window.subscriptionFlow.plan == '' || window.subscriptionFlow.plan == undefined){
            parent.querySelector('[error_message]').innerText = 'Please select the plan';
            return;
          }else{
            parent.querySelector('[error_message]').innerText = '';
            $this.setAttribute('disabled', true);
            $this.classList.add('loading');
          }
          subscriptionFunnel.prototype._AddToCart(event);
        })
      });
    }
    if(document.querySelector('[gift_popup_btn]')){
      document.querySelector('[gift_popup_btn]').addEventListener('click',(event)=>{
        subscriptionFunnel.prototype._AddToCart(event);
      })
    }
    if(window.globalVariables.templateSuffix == 'prepaid_gift'){
      document.querySelector('[prepaid_gift_select]').addEventListener('change',(event)=> {
        let _this = event.currentTarget;
        let current_gift = _this.options[_this.selectedIndex].getAttribute('data-value');
        this.changeprepaidGift('.giftvariantsJSON-'+current_gift)

      })
    }
  }
  changeprepaidGift(selected_gift){
    let variant_json = document.querySelector(selected_gift);
    let variantsArray = JSON.parse(variant_json.innerText);
    let selected_var = variantsArray.find(x=> x.variant_title.toLowerCase() == window.globalVariables.product.currentVariant.title.toLowerCase());
    let price = Utility.formatMoney(selected_var.price, window.globalVariables.money_format);
    let priceElement = document.querySelector('[data-currentPrice]');
    priceElement.innerHTML = price;
    document.querySelector('[data_price]').innerHTML = ' '+ price;
    window.prepaid_gift.variant_id = selected_var.variant_id
    window.prepaid_gift.selling_plan_id = selected_var.selling_plan_id
  }
  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    let has_selling = window.globalVariables.cart.items.find(x=> x.selling_plan_allocation);
    if (has_selling && window.globalVariables.templateSuffix != 'gift_card'){
      //document.querySelector('[frm_btn]').click();
      this.addToCart(this);
    }else{
      let popupparent = ''
      let parent = this.querySelector('[data-product-form]');
      if(document.querySelector('#is_gift')){
        if(document.querySelector('#is_gift input[type="hidden"]').value == ''){
           popupparent = document.querySelector('#pdp-subscription-modal');
        }else{
          popupparent = document.querySelector('#pdp-gift_subscription-modal');
        }
      }else{
        popupparent = document.querySelector('#pdp-subscription-modal') || document.querySelector('#pdp-gift_subscription-modal') ;
      }
      if(popupparent && parent){
        popupparent.querySelector('.modal').classList.add('open');
        siteOverlay.prototype.showOverlay();
      }else{
        this.addToCart(this);
      }
    }

    // submitButton.setAttribute('disabled', true); 
    // submitButton.classList.add('loading');
    // if( document.querySelector('[frm_btn]')){
    //   document.querySelector('[frm_btn]').addEventListener('click',()=>{
    //     this.addToCart();
    //   })
    // }
    if(document.querySelectorAll("[frm_btn]").length > 0){
      document.querySelectorAll("[frm_btn]").forEach(ele=>{
        ele.addEventListener("click" , (event)=>{
          this.addToCart(this);
        })
      });
    }
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  addToCart(_this){
    let form = '';
    if(_this){form = _this.querySelector('data-product-form')}

    const addItems = [];
    const qtyInput = document.querySelector('[data-qty-input]');
    const submitButton = document.querySelector('[addcart_btn]');
    
    if(window.globalVariables.template == 'product'){
      if(window.globalVariables.templateSuffix == 'prepaid_gift')
      {
        addItems.push({
          quantity: 1,
          id: parseInt(window.prepaid_gift.variant_id),
          selling_plan : window.prepaid_gift.selling_plan_id
        });
      }else if(form == null){
        addItems.push(JSON.parse(serializeForm(this.form))); /* cart upsell on pdp*/
      }else{
        addItems.push(JSON.parse(serializeForm(document.querySelector('[data-product-form]'))));
      }
    }else{
      addItems.push(JSON.parse(serializeForm(this.form)));
    }
    const body = JSON.stringify({
      items: addItems
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      console.log(dataJSON,"dataJSON");
      if(dataJSON.errors){
        if(dataJSON.errors.send_on){
          window.notificationEle.updateNotification('Add to Cart', dataJSON.errors.send_on[0], {
            type: 'error',
            timeout: 5000
          });
        }else{
          window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
            type: 'error',
            timeout: 5000
          });
        }
      }

      if(document.querySelector('#PopupModal-quickshop')){
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
      }
      if(document.querySelector('#pdp-subscription-modal')){
        document.querySelector('#pdp-subscription-modal .close-popup').dispatchEvent(new Event('click'))
      }
      if(document.querySelector('#pdp-gift_subscription-modal')){
        document.querySelector('#pdp-gift_subscription-modal .close-popup').dispatchEvent(new Event('click'))
      }
      if(qtyInput) qtyInput.value = 1;
      let cartElement = document.querySelector('cart-form');
      if(cartElement){
        cartElement.getCartData('open_drawer');
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }      
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      if(submitButton){
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      }
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
  Add_btn(event){
    event.preventDefault();
   
    let currentTarget = event.currentTarget;
    let has_selling = window.globalVariables.cart.items.find(x=> x.selling_plan_allocation);
    if (has_selling){
      this.onSubmitHandler(this)
    }else{
      this.onSubmitHandler(this)
       //let parent = document.querySelector('#pdp-subscription-modal');
      // parent.querySelector('.modal').classList.add('open');
      // siteOverlay.prototype.showOverlay();
      // parent.querySelector('[frm_btn]').addEventListener('click',()=>{
      //   this.onSubmitHandler(this)
      // })
    }
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
  }

  connectedCallback() {
    // Element Connected callback
    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    if(window.globalVariables.templateSuffix == 'prepaid_gift') {
      let gift_select = document.querySelector('[prepaid_gift_select]');
      let current_gift = gift_select.options[gift_select.selectedIndex].getAttribute('data-value');
      ProductForm.prototype.changeprepaidGift('.giftvariantsJSON-'+current_gift);
    }
    document.dispatchEvent(new Event('variant:changed'));
    
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = this.currentVariant[lableID];
    });

  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  // updateURLandID(currentVariant) {
  //   if (!currentVariant) return;

  //   if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

  //   const input = this.form.querySelector('input[name="id"]');
  //   input.value = currentVariant.id;
  // }
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if (this.formType === 'product-page') {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);
    }

    const input = this.form.querySelector('input[name="id"]');
    if (input) input.value = currentVariant.id;

    // Find the select element
    const select = document.getElementById('productSelectedSelect');
    if (select) {
        // Find the matching option
        const matchingOption = select.querySelector(`option[data-variant-id="${currentVariant.id}"]`);
        if (matchingOption) {
            select.value = currentVariant.id; // Update selected option

            // Get inventory info and update the div
            const inventoryInfoDiv = document.getElementById('inventory-info');
          const inventoryQty = matchingOption.getAttribute('data-inventory')
            if (inventoryInfoDiv) {
              if (inventoryQty < 9) {
                inventoryInfoDiv.textContent = `Only ${matchingOption.getAttribute('data-inventory')} left in stock!`;
              }
              else if (inventoryQty > 8) {
                inventoryInfoDiv.textContent = ` `;
              }
            }
        }
    }
}


  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let price = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    if(window.globalVariables.templateSuffix != 'prepaid_gift') {
      if(priceElement){
        priceElement.innerHTML = price;
        container.querySelector('[data_price]').innerHTML = ' '+ price;
      } 
    }
    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'block';
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_image.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;
    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = "combination " + window.variantStrings.unavailable + ", please choose an alternative.";
      
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddTextt;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);


// junaid code starts



/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const allcolorSwatchContainer = this.querySelectorAll('.color-swatch');
    if(allcolorSwatchContainer){
      allcolorSwatchContainer.forEach(colorSwatchContainer => {
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label span').setAttribute('style', swatchStyle);
        });
      });

      // const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      // colorSwatches.forEach(swatch => {
      //   let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
      //   let swatchStyle = Utility.getSwatchStyle(colorHandle);
      //   swatch.querySelector('.swatch-label span').setAttribute('style', swatchStyle);
      // });
    }
  }
}
customElements.define('variant-radios', VariantRadios);



